module.exports = __webpack_public_path__ + "img/154.64aaea08.jpg";